import Seo from "@/components/Seo";
import React from "react";
import { LegalPage, Section, P } from "@/components/Legal";

export default function Disclaimer() {
  return (
    <LegalPage title="Disclaimer" updated="July 4, 2026" testid="disclaimer-page">
      <Seo title="Disclaimer — WorldAIInfo" description="Important disclaimers about the data and content on WorldAIInfo." canonicalPath="/disclaimer" />
      <Section title="General Disclaimer">
        <P>The information on WorldAIInfo.com is provided for general informational purposes only. While we strive to keep information accurate and current we make no representations or warranties of any kind about the completeness, accuracy, reliability, or availability of any information on the platform.</P>
      </Section>

      <Section title="No Professional Advice">
        <P>Nothing on WorldAIInfo.com constitutes professional advice of any kind including financial advice, investment advice, legal advice, career advice, or technical advice. Always seek the advice of qualified professionals before making important decisions.</P>
      </Section>

      <Section title="AI Tools Disclaimer">
        <P>AI tools listed on WorldAIInfo.com are provided for informational purposes. We do not endorse any specific AI tool. AI tools can produce inaccurate, biased, or harmful outputs. Always verify AI-generated content before relying on it.</P>
      </Section>

      <Section title="Financial Disclaimer">
        <P>Any mention of AI stocks, company valuations, funding rounds, or financial information on WorldAIInfo.com is for informational purposes only and does not constitute financial or investment advice. Past performance does not guarantee future results. Always consult a qualified financial advisor before making investment decisions.</P>
      </Section>

      <Section title="Jobs Disclaimer">
        <P>Job listings are sourced from third parties and may not be current, accurate, or available. WorldAIInfo.com is not responsible for any aspect of the recruitment or employment process.</P>
      </Section>

      <Section title="Affiliate Disclaimer">
        <P>WorldAIInfo.com participates in affiliate programmes. We earn commissions on some links at no cost to you. See our full Affiliate Disclosure in our Terms of Service.</P>
      </Section>

      <Section title="External Links">
        <P>WorldAIInfo.com contains links to external websites. We have no control over external sites and are not responsible for their content or practices.</P>
      </Section>
    </LegalPage>
  );
}
